import React from 'react';
import ReactDOM from 'react-dom/client';

function isSavwDomain(hostname: string): boolean {
  if (!hostname) return false;

  const parts = hostname.toLowerCase().split('.');

  // 最基本防御
  if (parts.length < 3) return false;

  // root domain check
  const root = parts.slice(-2).join('.');
  if (root !== 'splashtop.com') return false;

  // label check
  return parts.includes('shield');
}

const RegisterRouter = React.lazy(() => import('@/pages/Register'));
const DefenderRouter = React.lazy(() => import('@/pages/Defender'));

let FinallyRouter = RegisterRouter;

const url = new URL(window.location.href);

if (url.searchParams.get('plan') === 'sav' || url.host.startsWith('sav-reg') || isSavwDomain(url.host)) {
  FinallyRouter = DefenderRouter;
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.Suspense>
    <FinallyRouter />
  </React.Suspense>
);